module.exports = __webpack_public_path__ + "static/media/icn-delete-20px-blue.ea64cac1.svg";